import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import CheckCircle from '../../../Icons/CheckCircle.js';
import Shield from '../../../Icons/Shield.js';
import XCircle from '../../../Icons/XCircle.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
import CommonEvent from './CommonEvents.js';
const EInvoiceEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.TransmissionStarted:
        case InteractionEventType.Sent:
        case InteractionEventType.Created:
        case InteractionEventType.Received:
            return null;
        case InteractionEventType.Delivered:
            return React.createElement(DeliveredEventCmp, { event: props.event });
        case InteractionEventType.Failed:
            return React.createElement(FailedEventCmp, { event: props.event });
        default:
            return React.createElement(CommonEvent, { event: props.event });
    }
};
const DeliveredEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    const bronze = event.bronzeData;
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(CheckCircle, { style: { margin: '0.15em 0 -0.15em' } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Delivered]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.deliveredAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            bronze?.documentId && (React.createElement(Box, { header: lang.interactions.eInvoiceEvents.documentId, body: bronze.documentId }))),
        bronze?.statusDetails && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.eInvoiceEvents.statusCode, body: String(bronze.statusDetails.statusCode) }),
            bronze.statusDetails.deliveryType && (React.createElement(Box, { header: lang.interactions.eInvoiceEvents.deliveryType, body: bronze.statusDetails.deliveryType }))))));
};
const FailedEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    const bronze = event.bronzeData;
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: { margin: '0.15em 0 -0.15em' } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Failed]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.failedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            bronze?.receiver?.name && (React.createElement(Box, { header: lang.interactions.eInvoiceEvents.receiver, body: bronze.receiver.name }))),
        bronze?.receiver?.cvr && (React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.eInvoiceEvents.receiverCvr, body: bronze.receiver.cvr }))),
        (bronze?.statusCode != null || bronze?.message != null) && (React.createElement(Row, null,
            bronze?.statusCode != null && (React.createElement(Box, { header: lang.interactions.eInvoiceEvents.statusCode, body: String(bronze.statusCode) })),
            bronze?.message != null && (React.createElement(Box, { header: lang.interactions.eInvoiceEvents.statusMessage, body: bronze.message }))))));
};
export default EInvoiceEventCmp;
//# sourceMappingURL=EInvoice.js.map